import { Coin } from "../../Coin/Coin";
import { Fraction } from "../../Fraction/Fraction";
import { Text } from "../../Text/Text/Text";
import styles from "./IngredientItem.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IngredientItem = function IngredientItem(_ref) {
  var ingredient = _ref.ingredient,
    points = _ref.points;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.ingredient,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.ingredientItem,
      "data-e2e-name": "ingredient_item",
      children: ingredient && /*#__PURE__*/_jsxs(Text, {
        typog: "bodycopy",
        className: styles.ingredientText,
        children: [/*#__PURE__*/_jsx("p", {
          className: styles.ingredientName,
          "data-e2e-name": "ingredient_name",
          children: " ".concat(ingredient.name)
        }), /*#__PURE__*/_jsxs("p", {
          className: styles.ingredientDescription,
          "data-e2e-name": "ingredient_description",
          children: [/*#__PURE__*/_jsx(Fraction, {
            children: ingredient.quantity
          }), ingredient.portion && /*#__PURE__*/_jsx("span", {
            children: " ".concat(ingredient.portion)
          }), ingredient.note && /*#__PURE__*/_jsx("span", {
            children: ", ".concat(ingredient.note)
          })]
        })]
      })
    }), (points || points === 0) && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Coin, {
        size: "small",
        value: points
      })
    })]
  });
};